export enum ImplementationStatus {
    None = 0,
    Implemented = 1,
    PartiallyImplemented = 2,
    Planned = 3,
    AlternativeImplementation = 4,
    NotApplicable = 5,
    NotImplemnented = 7
    //Ongoing = 6,
}
